<app-breadcrumb [master]="'Administracja'" [parentName]="'Import danych kontaktowych'"  [name]="'Lista importów'"></app-breadcrumb>
<div class="import-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
  </form>

  <div class="import-list-buttons"  fxLayout="row" fxLayoutAlign="space-between" >

    <div *ngIf="(userPermissions | async).import_contacts.write">
      <button   mat-raised-button color="primary" (click)="import()" ><mat-icon>add</mat-icon>  Zaimportuj</button>
    </div>

  </div>
  <table mat-table [dataSource]="imports">


    <ng-container matColumnDef="structure" >
      <th mat-header-cell *matHeaderCellDef style="text-align: center"> Struktura
      <td mat-cell *matCellDef="let element" style="text-align: center">
      {{element.structure?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data importu </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef> Nazwa pliku  </th>
      <td mat-cell *matCellDef="let element">
        {{element.fileName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Typ  </th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName}} {{element.createdBy.lastName}}</a>
        </ng-container>
        <ng-container *ngIf="!element.createdBy">
          System
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status  </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button  fxFlex="100"  mat-icon-button [matMenuTriggerFor]="menu"  *ngIf="(userPermissions | async).import_contacts.read"  ><mat-icon>expand_more</mat-icon></button>

        <mat-menu #menu="matMenu" xPosition="before">
          <button *ngIf="(userPermissions | async).import_contacts.read"   mat-menu-item (click)="downloadImportFile(element.uuid)">Pobierz plik importu</button>
        </mat-menu>


      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
